export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-array/src/identity.js
// module id = ../../../../d3-array/src/identity.js
// module chunks = 3